export default {
  DOWNLOAD: 'Download',
  PROCESSING: 'Verarbeitung',
  GENERAL_EVENT_INFO: 'Allgemeine Veranstaltungshinweise',
  EVENT_DETAILS: 'Veranstaltungsdetails',
  GENERATE_NEW: 'Neu generieren',
  REPORT_NOT_GENERATED:
    'Ihr Bericht wurde noch nicht erstellt oder es wurden bisher keine Leads erfasst. Bitte versuchen Sie es später erneut.',
  REPORT_DOWNLOADED: 'Bericht erfolgreich heruntergeladen',
  DOWNLOAD_REPORT: 'Bericht herunterladen',
  LAST_GENERATED: 'Bericht erstellt am',
  DOWNLOAD_REPORT_INFO: 'Das Erstellen eines neuen Berichts kann einen Moment dauern. Bitte lassen Sie diese Registerkarte geöffnet.'
}
